import clsx from 'clsx';
import React, {} from 'react';
const FormFieldLabel = ({ children, className }) => {
    return React.createElement("p", { className: clsx('form-field--label', className) }, children);
};
export default FormFieldLabel;
